import { render, staticRenderFns } from "./BaseEmptyState.vue?vue&type=template&id=03afb910&"
import script from "./BaseEmptyState.vue?vue&type=script&lang=js&"
export * from "./BaseEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports